<template>
  <div class="simulated-loader">
    <div class="loader-container">
      <i class="fa fa-refresh fa-spin fa-5x fa-fw"/>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Loader',
  props: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/library/loader.vue